import styled from 'styled-components'
import { maxWidth } from '@/assets/styles/mixins.css'
import vars from '@/assets/styles/vars'

const Work = styled.div`
  box-shadow: 0 0 0 1px var(--color-border);
`

Work.Image = styled.div`
  position: relative;

  &::after {
    content: '';
    display: block;
    padding-top: calc(2 / 3 * 100%);
  }

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

Work.Content = styled.div`
  padding: 24px 32px 32px;

  ${maxWidth(vars.breakpoints.tablet)`
    padding: 20px;
  `}
`

Work.Title = styled.h3`
  font-weight: normal;
  font-size: 20px;
  line-height: 1.4;
  color: var(--color-main);

  ${maxWidth(vars.breakpoints.tablet)`
    font-size: 18px;
  `}
`

Work.Date = styled.div`
  margin-top: 44px;
  font-weight: normal;
  font-size: 14px;
  line-height: 1.6;
  color: var(--color-extra);

  ${maxWidth(vars.breakpoints.tablet)`
    margin-top: 24px;
  `}
`

export default Work
